import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { CheckLg } from "react-bootstrap-icons";
import "../styles/waiting.css";

export default function Waiting({ isWaiting, list, message, isMulti = true }) {

  return (
    <Modal
      animation={false}
      show={isWaiting}
      centered
      backdrop="static"
      className="waiting_modal"
      data-testid="waiting_modal"
    >
      <Modal.Header>
        <Modal.Title>Please wait...</Modal.Title>
      </Modal.Header>
      <Modal.Body className="body">
        <div
          className="progress"
          role="progressbar"
          aria-label="Success example"
          aria-valuenow="25"
          aria-valuemin="0"
          aria-valuemax="100"
        >
          <div className="progress-bar bg-success progress-bar-striped progress-bar-animated" style={{ width: "100%" }}></div>
        </div>
      </Modal.Body>
    </Modal>
  );
}
